import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import DetailYoutubeEmbed from './detail-youtube-embed'
import useDetailStyles from '../detail-styles'
import DetailSection from './detail-section'
import {
  getActivityVideoMediaId,
  getAssessmentVideoMediaId,
} from '../lib/resolve-youtube-media-id'

const ActivityDetailContent = ({ hit }) => {
  const classes = useDetailStyles()
  const activityVideoId = getActivityVideoMediaId(hit)
  const assessmentTitle = hit.details?.assessmentTitle || 'Assessment'
  const assessmentText = hit.details?.assessmentText
  const assessmentVideoId = getAssessmentVideoMediaId(hit)
  const hasAssessmentContent =
    Boolean(assessmentText) ||
    Boolean(assessmentVideoId) ||
    Boolean(hit.details?.assessmentTitle)

  return (
    <>
      {activityVideoId ? (
        <DetailSection title="Video">
          <DetailYoutubeEmbed embedId={activityVideoId} />
        </DetailSection>
      ) : null}

      {hit.details?.summary ? (
        <DetailSection title="Summary">
          <Typography component="p" className={classes.bodyText}>
            {hit.details.summary}
          </Typography>
        </DetailSection>
      ) : null}

      {hit.details?.equipment ? (
        <DetailSection title="Equipment">
          <Typography component="p" className={classes.bodyText}>
            {hit.details.equipment}
          </Typography>
        </DetailSection>
      ) : null}

      {hit.details?.setup ? (
        <DetailSection title="Setup">
          <Typography component="p" className={classes.bodyText}>
            {hit.details.setup}
          </Typography>
        </DetailSection>
      ) : null}

      {hit.details?.detail ? (
        <DetailSection title="Instructions">
          <Typography component="p" className={classes.bodyText}>
            {hit.details.detail}
          </Typography>
        </DetailSection>
      ) : null}

      {hasAssessmentContent ? (
        <Box className={classes.section}>
          <Typography component="h2" className={classes.sectionEyebrow}>
            {assessmentTitle}
          </Typography>
          <Box className={classes.sectionCard}>
            {assessmentText ? (
              <Typography component="p" className={classes.bodyText}>
                {assessmentText}
              </Typography>
            ) : null}
            {assessmentVideoId ? (
              <Box
                className={assessmentText ? classes.videoWrapper : undefined}
              >
                <DetailYoutubeEmbed embedId={assessmentVideoId} />
              </Box>
            ) : null}
          </Box>
        </Box>
      ) : null}
    </>
  )
}

ActivityDetailContent.propTypes = {
  hit: PropTypes.object.isRequired,
}

export default ActivityDetailContent
